const ColumnDataType = {
    Bigint: "bigint",
    Boolean: "boolean",
    Date: "date",
    Decimal: "decimal",
    Json: "json",
    Numeric: "numeric",
    Time: "time",
    TimeP: "time\\(\\d+\\)",
    TimeWithTimeZone: "time with time zone",
    Timestamp: "timestamp",
    TimestampP: "timestamp\\(\\d+\\)",
    TimestampWithTimeZone: "timestamp with time zone",
    TimestampWithTimeZoneP: "timestamp with time zone\\(\\d+\\)",
    TimestampPWithTimeZone: "timestamp\\(\\d+\\) with time zone",
    Varchar: "varchar",
    VarcharP: "varchar\\(\\d+\\)",
    Uuid: "uuid"
};

export { ColumnDataType };
//# sourceMappingURL=types.js.map
